<template>
  <el-select
    v-model="orgCode"
    ref="capitalOrgRef"
    :loading="isLoading"
    size="small"
    :clearable="clearable"
    :multiple="multiple"
    @clear="onClear"
    :disabled="disable"
    filterable
    placeholder="请选择"
  >
    <el-option
      v-for="item in list"
      :label="item.orgName"
      :value="item.orgCode"
      :key="item.orgCode"
    />
  </el-select>
</template>

<script>
import { getCapitalOrgDictListAPI } from './api.js';

export default {
  name: 'SelectCapitalOrg',

  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disable: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    orgCode: {
      get() {
        return this.multiple ? this.value || [] : this.value || undefined;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  data() {
    return {
      list: [],
      isLoading: false,
    }
  },

  created() {
    this.getList();
  },

  methods: {
    async getList() {
      this.isLoading = true;
      try {
        this.list = await getCapitalOrgDictListAPI();
      } finally {
        this.isLoading = false;
      }
    },

    close() {
      this.$refs.capitalOrgRef.blur();
    },

    onClear() {
      this.$refs.capitalOrgRef.blur();
    },
  }
}
</script>
